import { ASSETS_GROUPS, type AssetGroup } from '@/entities/account';

type ComparisonAsset = {
  code: string;
  baseAvailable?: number;
  group?: AssetGroup;
};

export const exchangeAssetsComparator = (
  a: ComparisonAsset,
  b: ComparisonAsset
) => {
  const aIsFiat = a.group === ASSETS_GROUPS.fiat;
  const bIsFiat = b.group === ASSETS_GROUPS.fiat;

  if (aIsFiat !== bIsFiat) return aIsFiat ? -1 : 1;

  const baseAvailableDiff = (b.baseAvailable ?? 0) - (a.baseAvailable ?? 0);
  if (baseAvailableDiff !== 0) return baseAvailableDiff;
  return a.code.localeCompare(b.code);
};
